import React from 'react'

import { useSurvey } from '../../module/survey/hook'

import DeferredComponent from './DeferredComponent'
import SconnLoading from './SconnLoading'

export default function LoadingFallback() {
  const { surveyOnModal } = useSurvey()
  return (
    <DeferredComponent>
      <div
        className={`flex flex-col items-center w-full gap-5 ${surveyOnModal ? 'my-12' : 'my-28'}`}
      >
        <SconnLoading width={174} height={68} />
      </div>
    </DeferredComponent>
  )
}

export function LoadingFallbackFullScreen() {
  return (
    <DeferredComponent>
      <div className='absolute z-20 flex flex-col items-center justify-center w-screen h-screen gap-5 bg-white'>
        <div className='-translate-y-[50px]'>
          <SconnLoading width={174} height={68} />
        </div>
      </div>
    </DeferredComponent>
  )
}
